import { z } from 'zod';
import { Id, IsoDateTime, Currency } from './common.js';
import { PricingModel } from './billing.js';

export const PlatformScope = z.enum([
  'read_products',
  'read_inventory',
  'read_customers',
  'read_orders',
  'write_orders',
]);
export type PlatformScope = z.infer<typeof PlatformScope>;

export const Platform = z.object({
  platform_id: Id,
  name: z.string(),
  slug: z.string(),
  default_pricing_model: PricingModel,
  billing_currency: Currency,
  oauth_authorize_url: z.string().nullable(),
  oauth_token_url: z.string().nullable(),
  oauth_revoke_url: z.string().nullable(),
  api_base_url: z.string().nullable(),
  webhook_signing_secret_encrypted: z.string().nullable(),
  is_active: z.boolean(),
  is_listed: z.boolean(),
  contract_terms: z.record(z.unknown()).default({}),
  created_at: IsoDateTime,
});
export type Platform = z.infer<typeof Platform>;

export const PlatformConnection = z.object({
  connection_id: Id,
  platform_id: Id,
  merchant_id: Id,
  access_token_encrypted: z.string(),
  refresh_token_encrypted: z.string().nullable(),
  scopes: z.array(PlatformScope),
  token_expires_at: IsoDateTime.nullable(),
  external_merchant_id: z.string(),
  is_active: z.boolean(),
  last_synced_at: IsoDateTime.nullable(),
  created_at: IsoDateTime,
});

export const RedirectUri = z.object({
  redirect_id: Id,
  platform_id: Id,
  uri_pattern: z.string(),
  created_at: IsoDateTime,
});
